import React from 'react'
import PropTypes from 'prop-types'
import {Heading, Link as NavLink} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Link as RouteLink} from 'react-router-dom'
import usePdTagManager from '../../../../../hooks/use-pd-tag-manager'
import {useAppOrigin} from '@salesforce/retail-react-app/app/hooks/use-app-origin'

const CategoryTitle = ({
    title,
    titleColor,
    titleTag,
    titleSizeMobile,
    titleSizeTablet,
    titleSizeLargeDesktop,
    titleFontFamily,
    titleSizeSmallDesktop,
    titleAlign,
    shouldDisplayVideo,
    linkUrl,
    videoUrl,
    index,
    typeId
}) => {
    const appOrigin = useAppOrigin()
    const pdTagManager = usePdTagManager()
    const isExternalDomain = linkUrl?.indexOf('http') !== -1
    const linkProps =
        linkUrl && shouldDisplayVideo
            ? isExternalDomain
                ? {as: NavLink, href: linkUrl}
                : {as: RouteLink, to: linkUrl}
            : {}
    return (
        <Heading
            as={shouldDisplayVideo ? 'a' : titleTag}
            {...linkProps}
            textDecoration="unset !important"
            className="category-title"
            maxWidth={{base: '100%', md: 'unset'}}
            margin="0"
            fontSize={{
                base: titleSizeMobile,
                md: titleSizeTablet,
                lg: titleSizeSmallDesktop,
                xl: titleSizeLargeDesktop
            }}
            fontFamily={titleFontFamily || 'caslon'}
            fontWeight="400"
            lineHeight="normal"
            textAlign={titleAlign}
            color={titleColor || 'black'}
            _hover={{
                textDecoration: 'unset !important'
            }}
            onClick={() => {
                if (!shouldDisplayVideo) {
                    return
                }
                pdTagManager.selectComponent({
                    componentId: typeId,
                    componentName: name,
                    titleName: title,
                    titlePosition: index,
                    linkUrl: linkUrl?.indexOf('http') !== -1 ? linkUrl : `${appOrigin}${linkUrl}`,
                    videoUrl: videoUrl
                })
            }}
        >
            {title}
        </Heading>
    )
}

CategoryTitle.propTypes = {
    title: PropTypes.string,
    titleColor: PropTypes.string,
    titleSizeLargeDesktop: PropTypes.string,
    titleSizeMobile: PropTypes.string,
    titleFontFamily: PropTypes.string,
    titleSizeSmallDesktop: PropTypes.string,
    titleSizeTablet: PropTypes.string,
    titleTag: PropTypes.string,
    titleAlign: PropTypes.string,
    shouldDisplayVideo: PropTypes.bool,
    linkUrl: PropTypes.any,
    videoUrl: PropTypes.any,
    index: PropTypes.any,
    typeId: PropTypes.any
}

export default CategoryTitle
